module.exports = __webpack_public_path__ + "static/img/8.602bfcc5.png";